<template>
  <div class="home">
    <!-- 语言栏 -->
    <div class="topDemoLan">
      <div class="languageAndArea">
        <span class="chiose" @click="changeLang()">
          <svg-icon iconClass="vector"></svg-icon>
          <template v-if="langType === 'zh'">中文</template>
          <template v-else-if="langType === 'en'">EN</template>
        </span>
        <svg-icon iconClass="yx_icon_down"></svg-icon>
      </div>
      <router-link
        :to="{ name: 'loginAndRegister' }"
        class="loginRag"
        v-if="!userInfo.invitationCode"
      >
        <i class="el-icon-user langIcon"></i>
        <span class="text">{{ $t("home.loginRegistration") }}</span>
      </router-link>
      <p class="loginRag" v-else>
        <router-link class="text" :to="{ name: 'userpersonalData' }">
          <svg-icon iconClass="userIcon" class="userIcon"></svg-icon>
          {{ userInfo.invitationCode }}
        </router-link>
        <router-link
          class="text logoutText"
          :to="{ name: 'loginAndRegister' }"
          >{{ $t("home.exit") }}</router-link
        >
      </p>
      <router-link
        :to="{ name: 'shoppingCar' }"
        class="loginRag shopCar"
        v-if="userInfo.invitationCode"
      >
        <span class="text">
          <el-badge class="item" size="mini">
            <svg-icon iconClass="shopCarIcon" class="shopCarIcon"></svg-icon>
          </el-badge>
          {{ $t("home.shoppingCart") }}
        </span>
      </router-link>
    </div>

    <!-- 顶部菜单导航 -->
    <div
      class="topMenu"
      :style="{ position: topMenuFixed ? 'fixed' : 'relative' }"
    >
      <router-link :to="{ name: 'index' }" class="logoImgBox">
        <img
          :src="require('../assets/logos/logo.png')"
          alt="瑞杰创新"
          class="logo"
        />
      </router-link>
      <ul class="menuBox">
        <li class="aMenuItem">
          <router-link :to="{ name: 'index' }" class="routerDemo">{{
            $t("home.index")
          }}</router-link>
        </li>
        <li
          class="aMenuItem"
          @mouseenter="mouseInterProductMenuItem = true"
          @mouseleave="mouseInterProductMenuItem = false"
        >
          <router-link
            :to="{ name: 'products', params: { no: 'all' } }"
            class="routerDemo"
            >{{ $t("home.products") }}</router-link
          >
        </li>
        <li class="aMenuItem">
          <router-link :to="{ name: 'application' }" class="routerDemo">{{
            $t("home.application")
          }}</router-link>
        </li>
        <li class="aMenuItem">
          <router-link :to="{ name: 'enterpriseNews' }" class="routerDemo">{{
            $t("home.enterpriseNews")
          }}</router-link>
        </li>
        <el-dropdown style="z-index: 10500">
          <li class="aMenuItem">
            <router-link :to="{ name: 'aboutUS' }" class="routerDemo">{{
              $t("home.aboutUS")
            }}</router-link>
          </li>

          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <router-link
                :to="{ name: 'aboutUS', query: { active: 1 } }"
                class="dropdownRouterDemo"
                >{{ $t("home.aboutRJ") }}</router-link
              >
            </el-dropdown-item>
            <el-dropdown-item>
              <router-link
                :to="{ name: 'aboutUS', query: { active: 2 } }"
                class="dropdownRouterDemo"
                >{{ $t("home.joinUs") }}</router-link
              >
            </el-dropdown-item>
            <el-dropdown-item>
              <router-link
                :to="{ name: 'aboutUS', query: { active: 3 } }"
                class="dropdownRouterDemo"
                >{{ $t("home.callUs") }}</router-link
              >
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </ul>

      <!-- 商品类别下拉菜单 -->
      <div
        class="downMenuBox"
        v-show="showDownMenu"
        @mouseenter="mouseInterDownMenuItem = true"
        @mouseleave="mouseInterDownMenuItem = false"
      >
        <div class="downMenu">
          <template v-for="(item, indexLv1) in pullDownWindowData">
            <router-link
              class="aProductItem"
              :to="{ name: 'products', params: { no: itemLv2.no } }"
              v-for="(itemLv2, indexLv2) in item"
              :key="indexLv1 + '_' + indexLv2"
              v-show="itemLv2.classType != 0"
            >
              <el-image
                :src="itemLv2.photoa || require('@/assets/images/palnyImg.png')"
                class="productImg"
              ></el-image>
              <p class="productName">{{ itemLv2.name }}</p>
            </router-link>
          </template>
        </div>
      </div>
    </div>
    <div class="topMenu" v-if="topMenuFixed"></div>
    <router-view />

    <!-- 底部信息 -->
    <div class="footDemo">
      <div class="contentBox">
        <div class="menuDemo">
          <div class="aMenuList" style="width: 80px;">
            <router-link :to="{ name: 'index' }" class="modelName">{{
              $t("home.index")
            }}</router-link>
          </div>
          <div class="aMenuList">
            <router-link
              :to="{ name: 'products', params: { no: 'all' } }"
              class="modelName"
              >{{ $t("home.products") }}</router-link
            >
            <template v-for="(item, indexLv1) in pullDownWindowData">
              <router-link
                :to="{ name: 'products', params: { no: itemLv2.no } }"
                v-for="(itemLv2, indexLv2) in item"
                :key="indexLv1 + '_' + indexLv2"
                class="routerName"
                >{{ itemLv2.name }}</router-link
              >
            </template>
          </div>
          <div class="aMenuList">
            <router-link :to="{ name: 'application' }" class="modelName">{{
              $t("home.application")
            }}</router-link>
            <template v-for="(item, index) in applications">
              <router-link
                v-if="index < 6"
                :key="index"
                :to="{ name: 'application' }"
                class="routerName"
                >{{ item.appName }}</router-link
              >
            </template>
          </div>
          <div class="aMenuList">
            <router-link :to="{ name: 'enterpriseNews' }" class="modelName">{{
              $t("home.enterpriseNews")
            }}</router-link>

            <router-link
              :to="{ name: 'enterpriseNews', query: { active: 1 } }"
              class="routerName"
              >{{ $t("home.rjActive") }}</router-link
            >
            <router-link
              :to="{ name: 'enterpriseNews', query: { active: 2 } }"
              class="routerName"
              >{{ $t("home.industryNews") }}</router-link
            >
          </div>
          <div class="aMenuList" style="border-right: none;">
            <router-link :to="{ name: 'aboutUS' }" class="modelName">{{
              $t("home.aboutUS")
            }}</router-link>
            <router-link
              :to="{ name: 'aboutUS', query: { active: 1 } }"
              class="routerName"
              >{{ $t("home.aboutRJ") }}</router-link
            >
            <router-link
              :to="{ name: 'aboutUS', query: { active: 2 } }"
              class="routerName"
              >{{ $t("home.joinUs") }}</router-link
            >
            <router-link
              :to="{ name: 'aboutUS', query: { active: 3 } }"
              class="routerName"
              >{{ $t("home.callUs") }}</router-link
            >
          </div>
        </div>
        <div class="logoDemo">
          <img
            class="logo"
            :src="require('@/assets/logos/logo2.png')"
            alt="瑞杰"
          />

          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            style="font-size: 14px; color: #FFFFFF; margin-top: 20px; display: block;"
          >粤ICP备2021132305号-1</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGoodsCategory } from "@/apis/product/index.js";
import { selectApplication } from "@/apis/company/index.js";

export default {
  name: "home",
  data() {
    return {
      showDownMenu: false,
      mouseInterProductMenuItem: false,
      mouseInterDownMenuItem: false,

      pullDownWindowData: [], // 产品下拉框数据
      applications: [],

      topMenuFixed: false, // 顶部菜单栏是否吸顶
      showLogoutPop: false // 是否显示推出弹窗
    };
  },
  computed: {
    langType() {
      const langType = this.$store.getters.langType;
      return langType;
    },

    // 用户信息
    userInfo() {
      const userInfoStr = this.$selectSession("userInfo");
      let userInfo = {};
      try {
        userInfo = JSON.parse(userInfoStr);
      } catch (error) {}
      console.log(userInfo);
      return userInfo;
    }
  },
  methods: {
    // 切换语言
    changeLang() {
      const langType = this.$store.getters.langType;
      let nextLang = langType === "zh" ? "en" : "zh";
      this.$store.commit("SET_LANGTYPE", nextLang);
      this.$i18n.locale = nextLang;
      location.reload();
    },

    // 查询商品类别
    getProductCategory() {
      this.pullDownWindowData = [];
      getGoodsCategory().then(res => {
        let list = [];
        let maxLength = 6;
        for (var i in res) {
          i = parseInt(i);
          if (i == 0) {
            list.push(res[i]);
            continue;
          }
          if (i > 0 && (i + 1) % maxLength > 0 && i != res.length - 1) {
            list.push(res[i]);
          } else {
            list.push(res[i]);
            this.pullDownWindowData.push(list);
            list = [];
          }
        }
        this.pullDownWindowData = JSON.parse(
          JSON.stringify(this.pullDownWindowData)
        );
        // console.log(this.pullDownWindowData)
      });
    },

    // 应用信息
    selectApplication() {
      const data = {};
      selectApplication(data).then(res => {
        this.applications = res.data;
      });
    }
  },
  created() {
    this.getProductCategory();
    this.selectApplication();
  },
  mounted() {
    document.onscroll = e => {
      const scrollTop = e.target.documentElement.scrollTop;
      if (scrollTop > 25) {
        this.topMenuFixed = true;
      } else {
        this.topMenuFixed = false;
      }
    };
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler(val) {
        document.documentElement.scrollTop = 0;
      }
    },
    mouseInterProductMenuItem: function(val) {
      if (val || this.mouseInterDownMenuItem) {
        this.showDownMenu = true;
      } else {
        this.showDownMenu = false;
      }
    },
    mouseInterDownMenuItem: function(val) {
      if (val || this.mouseInterProductMenuItem) {
        this.showDownMenu = true;
      } else {
        this.showDownMenu = false;
      }
    }
  }
};
</script>
<style scoped>
.dropdownRouterDemo {
  text-decoration: none;
  font-family: 思源黑体;
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #3d3d3d;
  transition: 0.35s;
  display: block;
  width: 100%;
  height: 100%;
}

.dropdownRouterDemo:hover {
  color: #ff6f21;
}
</style>
<style lang="less" scoped>
.home {
  width: 100%;
  min-width: 1200px;

  @keyframes downMenuBoxShow {
    0% {
      height: 0px;
      opacity: 0px;
      bottom: -0px;
    }
    100% {
      height: 250px;
      opacity: 1px;
      bottom: -247px;
    }
  }

  .downMenuBox {
    width: 100%;
    height: 250px;
    padding: 0px;
    margin: 0px;
    background-color: #ffffff;
    position: absolute;
    bottom: -247px;
    left: 0px;
    z-index: 500;
    animation-name: downMenuBoxShow;
    animation-duration: 0.35s;
    box-shadow: 0px 10px 10px #b3b3b3;

    .downMenu {
      width: 1200px;
      height: 100%;
      max-height: 200px;
      margin: 20px calc(50% - 600px) 0px calc(50% - 600px);
      display: flex;
      justify-content: left;

      .aProductItem {
        width: 16.6666%;
        height: 100%;
        overflow: hidden;
        cursor: pointer;
        border-radius: 8px;
        text-align: center;
        transition: 0.35s;
        text-decoration: none;
        display: block;

        &:hover {
          background-color: #dbdbdb;
        }

        .productImg {
          width: 156px;
          height: 156px;
          padding: 10px;
          display: inline-block;
          border-radius: 8px;
          overflow: hidden;
        }
        .productName {
          width: 100%;
          font-family: Source Han Sans CN;
          font-size: 12px;
          font-weight: normal;
          color: #3d3d3d;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: keep-all;
          margin-top: 12px;
        }
      }
    }
  }

  .topDemoLan {
    width: 100%;
    height: 25px;
    background: #000000;
    padding: 0px 40px;
    text-align: right;

    .loginRag,
    .languageAndArea {
      display: inline-block;
      vertical-align: top;
      font-size: 12px;
      height: 100%;
      line-height: 25px;
      color: #ffffff;
      cursor: pointer;
    }

    .loginRag {
      margin-left: 30px;
      .text {
        color: #ffffff;
      }
      .logoutText {
        padding-left: 10px;
        margin-left: 10px;
        border-left: 1px solid #494949;
        color: #ffffff;
      }
    }
    .shopCar {
      /deep/.el-badge {
        padding-right: 15px;
        .el-badge__content {
          border: none;

          &.is-fixed {
            top: 7px;
            right: 20px;
          }
        }
      }
    }
  }

  .topMenu {
    width: 100%;
    height: 95px;
    background: #ffffff;
    padding: 0px 40px;
    position: relative;
    top: 0px;
    left: 0px;
    z-index: 1500;
    box-shadow: 0px 0px 10px #e6e6e6;

    .logoImgBox {
      width: min-content;
      height: 58px;
      position: relative;
      top: 15px;
      display: block;

      .logo {
        width: auto;
        height: 100%;
      }
    }

    .menuBox {
      position: absolute;
      right: 40px;
      top: 44px;
      // width: 400px;
      margin: 0px;
      text-align: right;

      .aMenuItem {
        padding: 0px 25px;
        font-family: HarmonyOS Sans SC;
        font-size: 14px;
        font-weight: bold;
        line-height: 14px;
        height: 50px;
        letter-spacing: 0.11px;
        color: #000000;
        display: inline-block;
        list-style-type: none;
        position: relative;
        word-break: keep-all;
        cursor: pointer;
        transition: color 0.35s;

        &::after {
          content: "";
          display: block;
          width: calc(100% + 40px);
          height: 3px;
          background-color: #ff6f21;
          position: absolute;
          top: 30px;
          left: -20px;
          opacity: 0;
          cursor: pointer;
          transition: all 0.35s;
        }

        .routerDemo {
          font-size: 14px;
          font-weight: bold;
          line-height: 14px;
          color: #000000;
          text-decoration: none;
        }

        &:hover {
          color: #666666;

          &::after {
            width: calc(100% - 50px);
            opacity: 1;
            left: 25px;
          }
        }
      }
    }
  }

  .footDemo {
    width: 100%;
    height: 260px;
    background: #2c445c;
    padding: 53px calc(50% - 600px) 49px calc(50% - 600px);

    .contentBox {
      width: 1200px;
      height: 100%;
      position: relative;

      .menuDemo {
        width: fit-content;
        height: 100%;

        .aMenuList {
          width: 147px;
          height: 100%;
          border-right: 1px solid #425f7b;
          display: inline-block;
          vertical-align: top;
          text-align: left;
          padding-left: 20px;

          .modelName,
          .routerName {
            font-weight: normal;
            line-height: 16.67px;
            color: #ffffff;
            cursor: pointer;
            transition: opacity 0.35s;
            opacity: 1;
            text-decoration: none;
            display: block;

            &:hover {
              opacity: 0.7;
            }
          }

          .modelName {
            font-family: Source Han Sans CN;
            font-size: 14px;
            margin-bottom: 22px;
            display: inline-block;
          }
          .routerName {
            font-family: Source Han Sans CN;
            font-size: 12px;
            margin-bottom: 8px;
          }
        }
      }
      .logoDemo {
        position: absolute;
        top: 12px;
        right: 0px;
        height: 70px;

        .logo {
          height: 100%;
          display: block;
        }
      }
    }
  }
}

.topCancelBtn,
.topLogoutBtn {
  border: none;
  cursor: pointer;
  transition: opacity 0.35s;
  padding: 4px 8px;
  border-radius: 5px;

  &:hover {
    opacity: 0.75;
  }
}
.topCancelBtn {
  background-color: #bdbdbd;
  color: #000000;
}
.topLogoutBtn {
  background-color: #ff6f21;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue